import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { AppleCertificateService } from './../shared/apple-cerificate.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, UserWizardService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { isString } from 'util';


@Component({
  selector: 'app-apple-certificate-info',
  templateUrl: './apple-certificate-info.component.html',
  styleUrls: ['./apple-certificate-info.component.scss'],
  providers: [AppleCertificateService, AdobeAnalyticsService]
})

export class AppleCertificateInfoComponent implements OnInit, AfterViewChecked {

  accordionList: any;
  accordionTitle: any;
  pageContent: any;
  appleCertificateSummary: any;
  confirmModalPopup: ConfirmModalPopupModel;
  modalClass: string;
  initModal: boolean;
  appleId: string;
  notiContent: any;
  appleCertificateAvailable: any;
  csrAvailable = false;
  previousPage: any;
  landingPageRoute: any;
  eventEmit: any;
  user: any;
  useMock = false;;
  isDisabled: any = false;
  renewAppleCertificate = false;

  constructor(private router: Router,
    private pageloaderService: PageLoaderService,
    private appleCertificateService: AppleCertificateService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private route: ActivatedRoute,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.accordionList = [];
    this.accordionTitle = 'What to expect';
    this.pageloaderService.setPageLoaderStatus(false);
    this.appleCertificateAvailable = this.appleCertificateService.getAppleInfo();
    if (this.appleCertificateAvailable) {
      this.csrAvailable = true;
    }
    this.user = authenticationService.getUser();
    this.useMock = this.utilityService.getEnvConfig().useMock;
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.appleId = '';
    let scenarios;
    if (sessionStorage.getItem('AppleCertificateUploaded')) {
      this.notiContent = { type: 'success', content: 'installed' };
      scenarios = 2;
    } else {
      this.notiContent = { type: '', content: '' };
      scenarios = 1;
    }
    this.accordionList = [{ id: 1, isActive: false, category: this.accordionTitle, content: '' ,
     ariaLabel: {
      'expand': 'Expand',
      'collapse': 'Collapse',
      }}];
    // this.appleCertificateService.pageContent(this.utilityService.getEnvConfig().contentUrl.applecertificate.info).
      // subscribe(respobj => {
        this.pageContent = this.route.snapshot.data.pageData.appleCertificateinfo;
        // this.pageContent = respobj;
        for (const i in this.pageContent.descriptionWithModal) {
          if(i && isString(this.pageContent.descriptionWithModal[i])) {
            this.pageContent.descriptionWithModal[i] = this.pageContent.descriptionWithModal[i].split(/[[\]]/);
          }
        }
        if(isString(this.pageContent.step1.steps))
        this.pageContent.step1.steps = this.pageContent.step1.steps.split('|');
        if(isString(this.pageContent.step2.steps))
        this.pageContent.step2.steps = this.pageContent.step2.steps.split('|');
        this.appleCertificateService.getAppleSummary(scenarios).
          subscribe(respobj2 => {
            this.appleCertificateSummary = respobj2;
            if(this.appleCertificateSummary.status === 'Nearing expiration'){
              sessionStorage.setItem("appleRenewal","true");
            } 
			else{
              sessionStorage.setItem("appleRenewal","false");
            }  			
            this.pageloaderService.setPageLoaderStatus(true);
          }, error => this.handleError(error, 'summary'));
      // });
      this.appleCertificateService.createPageLoadProperties('INFO', 'info');

  }

  ngAfterViewChecked() {
    if (sessionStorage.getItem('AppleCertificateUploaded')) {
      sessionStorage.removeItem('AppleCertificateUploaded');

      if (this.useMock && document.getElementById('scenariosSelect')) {
        document.getElementById('scenariosSelect')['value'] = '2';
      }
    }
    if(this.appleCertificateSummary.status === 'Nearing expiration' && this.renewAppleCertificate){
      document.getElementById('inputAppleid')['value'] = this.appleCertificateSummary.info.appleId;
      this.resetErrorMessage(this.appleCertificateSummary.info.appleId);
    }
  }

  handleError(error, type) {
    this.notiContent = { type: 'error', content: type };
    this.pageloaderService.setPageLoaderStatus(true);
  }

  scenarioChange(scenarios) {
    this.pageloaderService.setPageLoaderStatus(false);
    this.appleCertificateService.getAppleSummary(scenarios).
      subscribe(respobj2 => {
        this.appleCertificateSummary = respobj2;
        this.pageloaderService.setPageLoaderStatus(true);
      });
  }

  confirmModal(content, showCancel) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalMessage = content.message;
    this.confirmModalPopup.modalSubHeader = '';
    this.confirmModalPopup.modalHeader = content.header;
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;
    if (isDisabled) {
      this.confirmModalPopup.showConfirmButton = false;
    } else {
      this.confirmModalPopup.confirmButtonMessage = showCancel ? 'Remove' : 'Close';
      this.confirmModalPopup.confirmButtonAccessibilityText = content.AccessibilityText;
      this.confirmModalPopup.showCancelButton = showCancel;
    }
    this.modalClass = 'modal-lg';
    this.eventEmit = document.activeElement;
    this.initModal = true;
    this.appleCertificateService.createPageLoadProperties('REMOVEMODAL', 'RemoveModal');

  }

  closeModal(confirm) {
    this.initModal = false;
    this.appleCertificateService.createPageLoadProperties('INFO', 'info');
    if (confirm && this.confirmModalPopup.showCancelButton) {
      this.pageloaderService.setPageLoaderStatus(false);
      if (!this.utilityService.getEnvConfig().useMock) {
        this.appleCertificateService.deleteAppleCertificate(this.appleCertificateSummary.info.appleId).
        subscribe(respobj2 => {
          this.appleCertificateService.getAppleSummary(1).
          subscribe(respobj3 => {
            this.appleCertificateSummary = respobj3;
            this.pageloaderService.setPageLoaderStatus(true);
            this.notiContent = { type: 'success', content: 'removed' };
            if (this.useMock && document.getElementById('scenariosSelect')) {
              document.getElementById('scenariosSelect')['value'] = '1';
            }
          }, error => this.handleError(error, 'summary'));
        }, error => this.handleError(error, 'delete'));
      } else {
        this.appleCertificateService.getAppleSummary(1).
        subscribe(respobj3 => {
          this.appleCertificateSummary = respobj3;
          this.pageloaderService.setPageLoaderStatus(true);
          this.notiContent = { type: 'success', content: 'removed' };
          if (this.useMock && document.getElementById('scenariosSelect')) {
            document.getElementById('scenariosSelect')['value'] = '1';
          }
        }, error => this.handleError(error, 'summary'));
      }
    }
  }

  resetErrorMessage(value) {
    this.appleId = value;
    this.notiContent = { type: '', content: '' };
    this.isDisabled = false;
  }

  generateCSR(appleid) {
    this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formSubmit',
    'BC_Device_Apple_Certificate_EnterID_Submit', 'success', 'Success_Admit', 'Submit', 'Body', '/businessconsole/appleCertificate/upload');
    this.pageloaderService.setPageLoaderStatus(false);
    const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailReg.test(appleid)) {
      this.appleId = appleid;
      const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
      const csrSecurityCheck = ( impersonator && impersonator.id ) ? true : false;
      if (!this.utilityService.getEnvConfig().useMock && !csrSecurityCheck ) {
        this.appleCertificateService.generateCSR(this.appleId,sessionStorage.getItem("appleRenewal")).
        subscribe(respobj2 => {
          document.getElementById('inputAppleid')['value'] = '';
          this.appleCertificateService.setAppleInfo(this.appleId, '');
          this.router.navigate(['appleCertificate/upload']);
          // Adobe Analytics Success Type Starts appleCertificate/info
          this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formResponse',
          'BC_Device_Apple_Certificate_EnterID_Submit',
          'success', 'Success_Admit', 'Submit', 'Body', '/businessconsole/appleCertificate/upload');
          // End
        }, error => {
          this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'FAILURE', 'formResponse',
          'BC_Device_Apple_Certificate_EnterID_Submit',
          'CSR File Not Generated', 'Failure_User', 'Submit', 'Body', '/businessconsole/appleCertificate/info');
          this.notiContent = { type: 'error', content: 'apiError' };
          this.pageloaderService.setPageLoaderStatus(true);
          document.getElementsByClassName('apple-certificate-info')[0].scrollIntoView();
        });
      } else if (this.appleId.indexOf('invalid') !== -1) {
        this.notiContent = { type: 'error', content: 'apiError' };
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'FAILURE', 'formResponse',
        'BC_Device_Apple_Certificate_EnterID_Submit',
        'Invalid AppleId', 'Failure_user', 'Submit', 'Body', '/businessconsole/appleCertificate/info');
        document.getElementsByClassName('apple-certificate-info')[0].scrollIntoView();
      } else {
        this.appleCertificateService.setAppleInfo(this.appleId, '');
        this.adobeAnalyticsService.createAdobeEventProperties('APPLECERTIFICATE', 'SUCCESS', 'formResponse',
        'BC_Device_Apple_Certificate_EnterID_Submit',
        'success', 'Success_Admit', 'Submit', 'Body', '/businessconsole/appleCertificate/upload');
        if(!csrSecurityCheck){
          this.router.navigate(['appleCertificate/upload']);
        } else {
          this.pageloaderService.setPageLoaderStatus(true);
          this.isDisabled = true;
        }
      }
    } else {
      this.appleId = '';
      this.notiContent = { type: 'error', content: 'invalidAppId' };
      this.pageloaderService.setPageLoaderStatus(true);
    }
  }

  navigateToStepTwo() {
    this.router.navigate(['appleCertificate/upload']);
  }

  onclickOfCancel() {
    this.previousPage = this.appleCertificateService.getpreviousRoute();
    if (this.previousPage === '/appleCertificate/upload') {
      this.landingPageRoute = this.appleCertificateService.getlandingPageRoute();
      this.router.navigate([this.landingPageRoute]);
    } else {
      this.router.navigate([this.previousPage]);
    }
  }

  renewAppleCert() {
    this.renewAppleCertificate = true;
  }
}
